import MainLayout from '@/layouts/MainLayout.vue'
import PlaceholderPage from '@/components/common/PlaceholderPage.vue'

export default {
  path: '/energy-query',
  component: MainLayout,
  redirect: '/energy-query/overview',
  meta: { module: 'energyQuery', title: '能耗查询' },
  children: [
    {
      path: 'overview',
      name: 'EnergyQueryOverview',
      component: () => import('@/views/energy-query/Overview.vue'),
      meta: { title: '数据概览' }
    },
    {
      path: 'history',
      component: PlaceholderPage,
      meta: { title: '分类历史数据' }
    },
    {
      path: 'realtime',
      component: PlaceholderPage,
      meta: { title: '监测实时数据' }
    }
  ]
}
